module.exports = __webpack_public_path__ + "media/site_templates/www.hirecarpenters.com.au/images/our_services_1-58b7f45c6544300302f2aae6cbdbcf29.jpg";